<comp-dialog [showCloseIcon]="isCancelable()" [closeIconValue]="false">
  <ng-container comp-dialog-header-title>
    @if (data.customConfirmHeadlineKey) {
      <span translate="{{ data.customConfirmHeadlineKey }}"></span>
    } @else if (data.customConfirmHeadline) {
      <span>{{ data.customConfirmHeadline }}</span>
    } @else {
      @if (data.items) {
        {{
          'general.confirm.delete.headlineWithCount'
            | translate
              : {
                  count: data.items.length,
                  item: data.items[0],
                }
        }}
      } @else {
        {{ headline() }}
      }
    }
  </ng-container>
  <ng-container comp-dialog-content>
    @if (data.customConfirmMessageKey) {
      <span translate="{{ data.customConfirmMessageKey }}"></span>
    } @else if (data.customConfirmMessage) {
      <span>{{ data.customConfirmMessage }}</span>
    } @else {
      @if (data.items) {
        {{
          'general.confirm.delete.messageWithCount'
            | translate
              : {
                  count: data.items.length,
                  moreCount: data.items.length - maxItemCountToShow,
                  item: data.items[0],
                  items: data.items
                    .slice(0, data.items.length > maxItemCountToShow ? maxItemCountToShow : -1)
                    .join(', '),
                  lastItem: data.items[data.items.length - 1],
                }
        }}
      } @else {
        {{ message() }}
      }
    }
  </ng-container>
  <ng-container comp-dialog-footer>
    <comp-card-buttons>
      <ng-container ngProjectAs="[right]">
        @if (isCancelable()) {
          <button comp-button="secondary" type="button" (click)="onCancel()">
            {{ 'general.cancel' | translate }}
          </button>
        }
        <button comp-button [ngClass]="confirmButton().buttonClass" (click)="onConfirm()">
          @if (data.customConfirmButtonTitleKey) {
            <span translate="{{ data.customConfirmButtonTitleKey }}"></span>
          } @else if (data.customConfirmButtonTitle) {
            <span>{{ data.customConfirmButtonTitle }}</span>
          } @else {
            <span [translate]="confirmButton().titleKey"></span>
          }
        </button>
      </ng-container>
    </comp-card-buttons>
  </ng-container>
</comp-dialog>
